module.exports = __webpack_public_path__ + "static/media/zhongqiu.0cbd8efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/zhongqiu.png
// module id = 1868
// module chunks = 6